import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { PortalMessageTemplateDictionaryDataItem } from 'src/app/feature-module/message/models/PortalMessageTemplateDictionaryDataItem';
import { PortalMessageService } from '../../service/portal-message.service';

@Component({
  selector: 'app-portal-message-template-picker',
  templateUrl: './portal-message-template-picker.component.html',
  styleUrls: ['./portal-message-template-picker.component.scss']
})
export class PortalMessageTemplatePickerComponent extends DialogContentBase  implements OnInit {

  constructor(private portalMessageService: PortalMessageService,
    private fb:UntypedFormBuilder,public dialog: DialogRef) { super(dialog)}

  templates$: Observable<PortalMessageTemplateDictionaryDataItem[]>;
  selectedTemplate:PortalMessageTemplateDictionaryDataItem;
  @Input() sendingChannelTypeId:number;
  @Input() claimIdentifier:string;


  pickerForm: UntypedFormGroup;

  ngOnInit(): void {
    this.initDictionaries();
    this.pickerForm =  this.fb.group(
      {
        selectedTemplate: [this.selectedTemplate]
      }
  );
  }

  initDictionaries() {
    this.templates$ = this.portalMessageService.getPortalMessageTemplates(this.sendingChannelTypeId, this.claimIdentifier);
  }

  templateSelected(){
    this.selectedTemplate = this.pickerForm.controls['selectedTemplate'].value;
  }

  confirm(){
    this.dialog.close({ template: this.selectedTemplate });
  }
}
